import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';

const ProtectedRoute = () => {
  const { session, loading } = useUser();

  if (loading) return null;
  if (!session) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default ProtectedRoute;
